import { render } from "./TheBikesGenerals.vue?vue&type=template&id=233cfd65"
import script from "./TheBikesGenerals.vue?vue&type=script&lang=js"
export * from "./TheBikesGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__